import React from "react";

import { AW21 } from "../../../../js/database/database-aw21.js";

import TopMenuProducts from "../../../../components/topmenuproducts";
import SwiperInit from "../../../../components/SwiperInit";
import InfoItem from "../../../../components/infoItem";
import Loader from "../../../../components/loader";

import ShopifyMainComponent from "../../../../components/ShopifyMainComponent";
import GlobalMetaTags from "../../../../components/globalMetaTags";
import SizeChart from "../../../../components/sizeChart.js";

class SunsetPrintTshirtBlackII extends React.Component {

    render() {
        return (
            <div>
                <GlobalMetaTags
                    pageTitle={AW21.tops.SunsetPrintTshirtBlackII.itemName}
                />
                <Loader />
                <TopMenuProducts
                    name={AW21.tops.SunsetPrintTshirtBlackII.itemName}
                />
                <InfoItem
                    price={AW21.tops.SunsetPrintTshirtBlackII.itemPrice}
                    fabric={AW21.tops.SunsetPrintTshirtBlackII.itemFabric}
                />
                <SizeChart src={AW21.tops.SunsetPrintTshirtBlackII.sizeChart} />
                <div className="swiper-container" id="swiper">
                    <div className="swiper-wrapper">
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.SunsetPrintTshirtBlackII.picture01}
                                alt={AW21.alt}
                                width={AW21.imgWidth}
                                height={AW21.imgHeight}
                                loading="lazy"
                            />
                        </div>
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.SunsetPrintTshirtBlackII.picture02}
                                alt={AW21.alt}
                                width={AW21.imgWidth}
                                height={AW21.imgHeight}
                                loading="lazy"
                            />
                        </div>
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.SunsetPrintTshirtBlackII.picture03}
                                alt={AW21.alt}
                                width={AW21.imgWidth}
                                height={AW21.imgHeight}
                                loading="lazy"
                            />
                        </div>
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.SunsetPrintTshirtBlackII.picture04}
                                alt={AW21.alt}
                                width={AW21.imgWidth}
                                height={AW21.imgHeight}
                                loading="lazy"
                            />
                        </div>


                    </div>
                </div>
                <ShopifyMainComponent
                    divId={AW21.tops.SunsetPrintTshirtBlackII.shopifyDivId}
                    mainId={AW21.tops.SunsetPrintTshirtBlackII.shopifyId}
                />
                <SwiperInit />
            </div>
        );
    }
}

export default SunsetPrintTshirtBlackII;
